import { render, staticRenderFns } from "./ClientDeleteModal.vue?vue&type=template&id=4ece5858&scoped=true&"
import script from "./ClientDeleteModal.vue?vue&type=script&lang=js&"
export * from "./ClientDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ece5858",
  null
  
)

export default component.exports